export function transformYandexUrl(url: string, name: string): string {
  const isPixel = ['click_audit_pixel', 'pixel', 'pixel_additional', 'pixel_additional2'].includes(name);
  const isLink = name === 'link';
  
  // Если не Yandex или не link/pixel поле - возвращаем как есть
  if (!url.includes('amc.yandex.ru') || (!isLink && !isPixel)) {
    return url;
  }
  
  // Для link поля - без изменений
  if (isLink) {
    return url;
  }
  
  // Для pixel поля
  if (isPixel) {
    // Проверяем, что это /show ссылка
    if (!url.includes('/show')) {
      return url;
    }
    
    // Просто заменяем значение rnd параметра
    return url.replace(/([?&]rnd=)[^&]*/g, '$1{RND}');
  }
  
  return url;
}